<template>
  <div class="container_box">
    <Tabs v-model="warehouseMode" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in warehouseModeList" :label="item.name" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002327')" prop="name">
              <Input v-model.trim="pageParams.name" :placeholder="$t('key1002597')" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="warehouseMode === 'supplierWarehouse'">
            <FormItem :label="$t('key1002359')" prop="aliasWarehouseName">
              <Input v-model.trim="pageParams.aliasWarehouseName" :placeholder="$t('key1002343')" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002433')" prop="ymsDeliveryPlaceId">
              <Select v-model="pageParams.ymsDeliveryPlaceId">
                <Option v-for="item in placeOfShipmentList" :key="item.ymsDeliveryPlaceId" :value="item.ymsDeliveryPlaceId">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002598')" prop="countryCode">
              <Select v-model="pageParams.countryCode" filterable>
                <Option v-for="item in countrysList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="warehouseMode === 'platformWarehouse'">
            <FormItem :label="$t('key1002599')" prop="collectionWarehouse">
              <Select v-model="pageParams.collectionWarehouse">
                <Option v-for="item in canWeStockUpList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="warehouseMode === 'platformWarehouse'">
            <FormItem :label="$t('key1002434')" prop="stockedWarehouse">
              <Select v-model="pageParams.stockedWarehouse">
                <Option v-for="item in canWeStockUpList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="warehouseMode === 'platformWarehouse'">
            <FormItem :label="$t('key1002164')">
              <local-tabButton :tabButtonList="statusList" @selectStatus="statusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="warehouseMode === 'supplierWarehouse'">
            <FormItem :label="$t('key1002600')" prop="supplierMerchantSearch">
              <Input v-model.trim="pageParams.supplierMerchantSearch" :placeholder="$t('key1002601')" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="warehouseMode === 'supplierWarehouse'">
            <FormItem :label="$t('key1002354')" prop="supplierWarehouseType">
              <Select v-model="pageParams.supplierWarehouseType">
                <Option v-for="item in supplierWarehouseTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="warehouseMode === 'platformWarehouse'">
      <!--新增仓库-->
      <Button class="mr15" type="primary" @click="$refs['addWarehouse'].initWarehouse('add')"
        v-if="getPermission('ymsWarehouse_insert')">{{ $t('key1002414') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        :max-height="tableHeight"
        :columns="tableColumns"
        :data="tableData"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增仓库弹窗-->
    <warehouseModal
      ref="addWarehouse"
      :warehouseTypeList="warehouseTypeList"
      :ymsThreeWarehouseSetList="ymsThreeWarehouseSetList"
      :countrysOriginalData="countrysOriginalData"
      @updateWarehouseData="updateWarehouseData">
    </warehouseModal>
    <!--查看编辑供应商仓弹窗-->
    <supplierWarehouseModal
      ref="supplierWarehouse"
      :countrysOriginalData="countrysOriginalData"
      @updateData="pageParamsStatus = true">
    </supplierWarehouseModal>
    <!--3PL物流渠道绑定弹窗-->
    <logisticsBindingModal ref="logisticsBinding"></logisticsBindingModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import warehouseModal from "@/views/yms/components/basicSettings/warehouseModal";
import supplierWarehouseModal from "@/views/yms/components/basicSettings/supplierWarehouseModal.vue";
import {commonLocalStorage, getAllCountrysData, getBatchDeliveryAreasName, getDataSetBatchList, getEnumList, getPlaceOfShipmentCountryData} from "@/utils/common";
import logisticsBindingModal from "@/components/common/logisticsBindingModal.vue";

export default {
  name: "warehouseManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        name: '',
        aliasWarehouseName: '',
        ymsDeliveryPlaceId: null,
        collectionWarehouse: 'null',
        stockedWarehouse: 'null',
        supplierWarehouseType: 'null',
        countryCode: null,
        status: null,
        supplierMerchantSearch: '',
        orderBy: 'createdTime',
        upDown: 'down',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'name',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002579'),
          key: 'aliasWarehouseName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let isDeliveryWarehouse = params.row.isDeliveryWarehouse === 1;
            let text = isDeliveryWarehouse ? (params.row.aliasWarehouseName || '-') : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002580'),
          key: 'code',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002581'),
          key: 'warehouseType',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let text = '';
            if (v.warehouseMode === 'platformWarehouse') {
              let warehouseType = params.row.warehouseType;
              v.warehouseTypeList.map((item) => {
                if (item.value === warehouseType) {
                  text = item.name;
                }
              });
            } else {
              let isCollectionWarehouseTalg = params.row.isCollectionWarehouse === 1;
              let isDeliveryWarehouseTalg = params.row.isDeliveryWarehouse === 1;
              text = isCollectionWarehouseTalg && isDeliveryWarehouseTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002582')
                : isCollectionWarehouseTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002114') : isDeliveryWarehouseTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002115') : '-';
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002583'),
          key: 'collectionWarehouse',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let collectionWarehouse = params.row.collectionWarehouse;
            let text = '';
            v.canWeStockUpList.map((item) => {
              if (item.value === collectionWarehouse) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002584'),
          key: 'stockedWarehouse',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let stockedWarehouse = params.row.stockedWarehouse;
            let text = '';
            v.canWeStockUpList.map((item) => {
              if (item.value === stockedWarehouse) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002585'),
          key: 'deliveryPlaceName',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002586'),
          key: 'countryCode',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let twoCode = params.row.countryCode || null;
            let text = '';
            if (v.countrysList.length > 0) {
              v.countrysList.map((item) => {
                if (item.twoCode === twoCode) {
                  text = item.cnName;
                }
              });
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002587'),
          key: 'supplierMerchantName',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let supplierMerchantId = params.row.supplierMerchantId;
            let supplierMerchantName = params.row.supplierMerchantName;
            return h('div', {class: 'text-align-left'}, [
              h('p', supplierMerchantName),
              supplierMerchantName ? h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000090') + supplierMerchantId) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002157'),
          key: 'status',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let warehouseType = params.row.warehouseType;
            let talg = warehouseType === 2 && v.ymsThreeWarehouseSetList.length <= 0;
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
            ];
            let status = params.row.status;
            return h('div', {class: 'flex align-items-center justify-content-center'}, [
              h('Badge', {
                props: {
                  status: typeList[status].type,
                  text: typeList[status].text || '-'
                },
                class: status === 0 ? 'stopStatus' : ''
              }),
              talg && h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 500,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002588'),
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  props: {
                    color: '#6c6c6d',
                    type: 'ios-information-circle',
                    size: 18
                  },
                  class: 'cursor ml5'
                })
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          minWidth: 180,
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let ymsWarehouseId = params.row.ymsWarehouseId;
            let warehouseType = params.row.warehouseType;
            let talg = !(v.resetoptionsStyles && warehouseType === 2);
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsWarehouse_detail') && v.warehouseMode === 'platformWarehouse',
                    styles: warehouseType === 2 ? v.resetoptionsStyles : '',
                    clickFn: () => {
                      if (talg) {
                        v.$refs['addWarehouse'].initWarehouse('look', ymsWarehouseId);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsWarehouse_update') && v.warehouseMode === 'platformWarehouse',
                    styles: warehouseType === 2 ? v.resetoptionsStyles : '',
                    clickFn: () => {
                      if (talg) {
                        v.$refs['addWarehouse'].initWarehouse('edit', ymsWarehouseId);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && v.getPermission('ymsWarehouse_enable') && v.warehouseMode === 'platformWarehouse',
                    styles: warehouseType === 2 ? v.resetoptionsStyles : '',
                    clickFn: () => {
                      if (talg) {
                        v.operationHandel('enable', params.row.ymsWarehouseId);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: params.row.status === 1 && v.getPermission('ymsWarehouse_disable') && v.warehouseMode === 'platformWarehouse',
                    color: '#ed4014',
                    styles: warehouseType === 2 ? v.resetoptionsStyles : '',
                    clickFn: () => {
                      if (talg) {
                        v.operationHandel('disable', params.row.ymsWarehouseId);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('ymsWarehouse_updateSupplierSetting') && v.warehouseMode === 'supplierWarehouse',
                    clickFn: () => {
                      v.$refs['supplierWarehouse'].initSupplierWarehouseData(params.row);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      supplierWarehouseTypeList: [
        {value: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002114')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002115')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002582')}
      ],
      countrysOriginalData: [],
      warehouseMode: 'platformWarehouse',
      warehouseModeList: [
        {value: 'platformWarehouse', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002589')},
        {value: 'supplierWarehouse', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002590')}
      ],
      placeOfShipmentList: [],
      canWeStockUpList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')},
      ],
      countrysList: [],
      statusList: [
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
      ],
      enumData: []
    };
  },
  computed: {
    // 运营端三方仓配置的可选值
    ymsThreeWarehouseSetList() {
      const configItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return configItems?.ymsThreeWarehouseSetSaas || [];
    },
    currencyState() {
      return this.$store.state.currency;
    },
    tableHeight() {
      return this.warehouseMode === 'platformWarehouse' ? '450' : '520';
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    resetoptionsStyles() {
      let styles = {
        color: '#c5c8ce',
        cursor: 'not-allowed'
      };
      return this.ymsThreeWarehouseSetList.length <= 0 ? styles : '';
    },
    // 仓库类型
    warehouseTypeList() {
      const ENUM_KEY = 'YmsWarehouseWarehouseTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.handleColumns();
      (async () => {
        let enumKeyList = ['YmsWarehouseWarehouseTypeCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllCountrysData().then((data) => {
          this.countrysOriginalData = data;
          this.getList();
        });
      })();
    },
    // 获取发货地与国家信息数据
    getPlaceOfShipmentCountryList() {
      getPlaceOfShipmentCountryData(this.warehouseMode).then((obj) => {
        let countryCodes = obj.countryCodes || [];
        this.placeOfShipmentList = obj.ymsDeliveryPlaces || [];
        this.countrysList = this.countrysOriginalData.filter((item) => {
          return countryCodes.includes(item.twoCode);
        });
      });
    },
    // 切换Tab
    changeTab() {
      this.handleColumns();
      this.$nextTick(() => {
        this.$refs['pageParams'].resetFields();
        this.statusBtn(0, null);
        this.search();
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
      this.updateWarehouseData();
    },
    // 重置按钮
    reset() {
      this.$nextTick(() => {
        this.$refs['pageParams'].resetFields();
        this.statusBtn(0, null);
        this.search();
      });
    },
    // 处理接口参数
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      if (v.warehouseMode === 'platformWarehouse') {
        let keyList = ['collectionWarehouse', 'stockedWarehouse'];
        for (let key of keyList) {
          params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
        }
        params.servicePlatform = 'core';
      } else {
        params.status = null;
        params.collectionWarehouse = null;
        params.stockedWarehouse = null;
        params.servicePlatform = 'supplier';
        let keyList = ['supplierWarehouseType'];
        for (let key of keyList) {
          params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
        }
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.total = 0;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.getPlaceOfShipmentCountryList();

      function handleData(url) {
        v.axios.post(url, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.total = data.total;
              let list = data.list || [];
              const ymsDeliveryPlaceIdList = list.map(item => item.ymsDeliveryPlaceId).filter(id => id);
              if (ymsDeliveryPlaceIdList.length > 0) {
                getBatchDeliveryAreasName(ymsDeliveryPlaceIdList).then((newData) => {
                  const nameMap = new Map(newData.map(ele => [ele.ymsDeliveryPlaceId, ele.deliveryPlaceName]));
                  list.forEach(item => {
                    if (nameMap.has(item.ymsDeliveryPlaceId)) {
                      item.deliveryPlaceName = nameMap.get(item.ymsDeliveryPlaceId);
                    }
                  });
                  v.tableData = list;
                  v.updateTableDom('selection');
                });
              } else {
                v.tableData = list;
                v.tableLoading = false;
              }
            }
          } else {
            v.tableLoading = false;
          }
        });
      }

      switch (v.warehouseMode) {
        case 'platformWarehouse':
          if (v.getPermission('ymsWarehouse_query')) {
            v.tableLoading = true;
            handleData(api.post_ymsWarehouse_query);
          } else {
            v.gotoError();
          }
          break;
        case'supplierWarehouse':
          if (v.getPermission('ymsWarehouse_querySupplier')) {
            v.tableLoading = true;
            handleData(api.post_ymsWarehouse_querySupplier);
          } else {
            v.gotoError();
          }
          break;
      }
    },
    // 启用、停用仓库按钮
    operationHandel(type, ymsWarehouseId) {
      let url = '';
      let v = this;
      if (type === 'disable') {
        url = api.put_ymsWarehouse_disable;
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002591'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002592'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            handleData(url, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472'));
          },
          onCancel: () => {
          }
        });
      } else {
        url = api.put_ymsWarehouse_enable;
        handleData(url, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473'));
      }

      function handleData(url, text) {
        v.axios.put(url + ymsWarehouseId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.getList();
            v.$Message.success(text);
          }
        });
      }
    },
    // 选取状态
    statusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.statusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 处理列表字段
    handleColumns() {
      let hideKeyColumns = [];
      switch (this.warehouseMode) {
        // 平台仓
        case 'platformWarehouse':
          hideKeyColumns = ['supplierMerchantName', 'aliasWarehouseName'];
          break;
        // 供应商仓
        case 'supplierWarehouse':
          hideKeyColumns = ['code', 'collectionWarehouse', 'stockedWarehouse', 'status'];
          break;
      }
      this.tableColumns = this.originalColumns.filter((item) => {
        return !hideKeyColumns.includes(item.key);
      });
    },
    // 更新仓库信息
    updateWarehouseData(data) {
      let v = this;
      if (data) {
        if (data.isPop) {
          let carrierShippingMethods = data.carrierShippingMethods || [];
          let carrierShippingMethodWarehouses = data.carrierShippingMethodWarehouses || [];
          let carrierNameList = [];
          let carrierCodeList = [];
          carrierShippingMethods.map((item) => {
            if (['temuHalfTl', 'tiktok'].includes(item.carrierCode)) {
              if (carrierShippingMethodWarehouses.includes(item.shippingMethodId)) {
                carrierNameList.push(item.carrierName);
                carrierCodeList.push(item.carrierCode);
              }
            }
          });
          carrierNameList = v.uniqueFunc(carrierNameList);
          carrierCodeList = v.uniqueFunc(carrierCodeList);
          let obj = {
            winitoutstore: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002593'),
            miyunoutstore: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002594')
          }
          let overseasWarehouseName = obj[data.carrierCode] || '';
          let contentHtml = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002572')}<span class="themeColor ml2 mr2">${carrierNameList.join('、')}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002573')}
                          ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002574')}${overseasWarehouseName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002575')}
                          ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002576')}<span class="themeColor ml2 mr2">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002577')}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002578')}`;
          if (carrierCodeList.length > 0) {
            v.$Modal.confirm({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002595'),
              width: 500,
              content: contentHtml,
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002596'),
              cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
              closable: true,
              onOk: () => {
                v.$refs['logisticsBinding'].initLogisticsBindingData('all', data, carrierCodeList);
              },
              onCancel: () => {
              }
            });
          }
        }
      }
      v.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    logisticsBindingModal,
    warehouseModal,
    supplierWarehouseModal
  }
};
</script>

<style scoped>

</style>
